module.exports = __webpack_public_path__ + "static/media/go_back_icon_white.94f289b7.svg";